<!-- 货主费用登记 -->
<template>
   <div>
      <div>
         <div class="demo-drawer__content data_action_form">
            <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
               <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val)=>{showTabs=val}">
                  <template slot="tabs" slot-scope="scope">
                     <!-- 商品信息 -->
                     <div class="table_content_box" v-if="scope.index == 0">
                        <el-form label-width="110px" id="mainInfo" class="baseForm" size="mini" :model="sendDataInfo" ref="sendDataInfo" :show-message="false"
                                 :disabled="dataActionBox.actionType>=2 && dataActionBox.actionType != 7  ? true : false ">
                           <el-row>
                              <el-form-item v-if="formOneValue.isShow==1" :label="formOneValue.showField" :id="formOneValue.entityField" :prop="formOneValue.entityField"
                                            v-for="(formOneValue,formOneKey) in scope.row.jurconfigform" :key="formOneKey" :rules="formOneValue.isRequired == 1 ? [{required: true, trigger: ['blur', 'change']}] : []"
                                            :hide-required-asterisk="formOneValue.isRequired == 1 ? true : false">
                                 <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                 <template>
                                    <df-date v-if="formOneValue.fieldType == 'date'" v-model="sendDataInfo[formOneValue.entityField]" :isdisabled="formOneValue.isChange == 0">
                                    </df-date>
                                    <el-tooltip v-else-if="formOneValue.fieldType == 'search'" class="item"
                                                :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''?true:false || sendDataInfo[formOneValue.entityField].length<=9"
                                                effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                       <el-input clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                 @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField,formOneValue.setField)" :disabled="formOneValue.isChange == 0">
                                          <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField,formOneValue.setField)" slot="append" icon="el-icon-search"
                                                     :disabled="formOneValue.isChange == 0">
                                          </el-button>
                                       </el-input>
                                    </el-tooltip>
                                    <el-input @input="inputChange(formOneValue.entityField)" @keyup.enter.native="nextFocus(formOneKey)" v-else-if="formOneValue.fieldType == 'number'" type="number" clearable
                                              v-model.trim="sendDataInfo[formOneValue.entityField]" :disabled="formOneValue.isChange == 0"></el-input>
                                    <el-input @keyup.enter.native="nextFocus(formOneKey)" v-else clearable v-model.trim="sendDataInfo[formOneValue.entityField]" :disabled="formOneValue.isChange == 0"></el-input>
                                 </template>
                              </el-form-item>
                           </el-row>
                        </el-form>
                     </div>
                  </template>
               </v-tabs>
            </el-card>
            <div class="foots">
               <el-button type="primary" @click="initActionBox('sendDataInfo')" v-if="dataActionBox.actionType!=2">取消</el-button>
               <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType==0||dataActionBox.actionType==1">保存</el-button>
            </div>
         </div>
      </div>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
         <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
   </div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import SearchScheme from "../byComponents/SearchScheme.vue";
export default {
   name: "priceListAdminAction",
   props: ['actionData'],
   //import引入的组件需要注入到对象中才能使用
   components: {
      SearchScheme,
   },
   data() {
      //这里存放数据
      return {
         dataActionBox: {
            showStatus: false,
            openMode: "ltr" ,
            boxTitle: "新增",
            actionType: 0, // 0新增，1修改
         },
         sendDataInfo: {},
         showTabs: "",
         formDataList: [],
         seId: "",
         seWidth: "",
         height: "",
         seTitle: "",
         seWidth: "",
         DialogVisible: false,
         seType: "",
         sField: "",
         smId: "",
         parentSearchData: {},
         mxHeight: 0,
         tabForm: [],
         mxForm: [],
         footForm: [],
         inputel: [],
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      "sendDataInfo.bgmName": {
         handler: function (newValue, oldValue) {
            if (newValue == '') {
               this.sendDataInfo.bgmId=""
               this.sendDataInfo.spec=""
               this.sendDataInfo.manufacturer=""
            }
         },
         deep: true,
      },
      "sendDataInfo.cmName": {
         handler: function (newValue, oldValue) {
            if (newValue == '') {
               this.sendDataInfo.cmId=""
            }
         },
         deep: true,
      },
   },
   //方法集合
   methods: {
      inputChange(type) {
         this.$set(this.sendDataInfo, type, this.$common.updataNum(type, this.sendDataInfo)[type])
      },
      // 获取主表单所有input
      getMainInput() {
         var el = document.getElementById('mainInfo')
         if (el) this.inputel = el.getElementsByTagName('input')
      },
      // 初始化焦点
      initFocus() {
         for (let index = 0; index < this.inputel.length; index++) {
            if (this.inputel[index].value == '' && this.inputel[index].disabled == false) {
               this.inputel[index].focus()
               break
            }
         }
      },
      // 输入框切换焦点
      nextFocus(index) {
         if (index >= (this.inputel.length - 1)) return
         if (this.inputel[index].value == "" || this.inputel[index].value == 0) {
            this.inputel[index].focus()
            return
         }
         var aindex = index + 1
         if (this.inputel[aindex].value != '' || this.inputel[aindex].value != 0 || this.inputel[aindex].disabled) {
            this.nextFocus(aindex)
            return
         }
         this.inputel[aindex].focus()
      },
      getSeWidth(e) {
         this.seWidth = e + "%";
      },
      getWidth(e) {
         this.exWidth = e + "%";
      },
      getSearchName(e) {
         this.seTitle = e;
      },
      //检索Id, 索引(表格中), 标识
      openSearch(sId, index, type, sField) {
         this.DialogVisible = true;
         this.seId = sId;
         this.seIndex = index;
         this.seType = type;
         this.sField = sField;
         this.parentSearchData[type] = this.sendDataInfo[type]
      },
      changeInputModel(val) {
         if (val != "" || val != undefined) {
            this.paramValue(val);
            this.DialogVisible = false;
         }
      },
      // 赋值字段
      paramValue(val) {
         let arr = this.sField.split(',')
         arr.forEach(item => {
            this.sendDataInfo[item] = val[item]
         })
         this.$nextTick(() => {
            this.nextFocus(this.seIndex)
         })
      },
      initActionBox(sendDataInfo) {
         this.dataActionBox.actionType = 0;
         this.$emit('drawerCancel')
         this.init();
         this.$refs[sendDataInfo].resetFields();
      },
      init() {
         for (let key in this.sendDataInfo) {
            this.sendDataInfo[key] = "";
         }
      },
      openBox() {
         this.dataActionBox.actionType = this.actionData.cate
         this.formDataList = this.actionData.formData;
         var oldData = this.actionData.oldData
         this.showTabs = this.actionData.formData[0].jciName;
         this.filterMainField()
         if (this.dataActionBox.actionType == 0) {
            this.dataActionBox.boxTitle = "新增信息";
         } else if (this.dataActionBox.actionType == 1) {
            this.dataActionBox.boxTitle = "编辑信息";
            for (let key in oldData) {
               this.sendDataInfo[key] = oldData[key];
            }
         } else {
            this.dataActionBox.boxTitle = '查看信息'
            var dataInfo = JSON.parse(JSON.stringify(oldData))
            for (let key in dataInfo) {
               this.sendDataInfo[key] = dataInfo[key]
            }
         }
         this.$nextTick(() => {
            this.initFocus()
         })
      },
      sendDataAction(sendDataInfo) {
         this.$refs[sendDataInfo].validate((valid) => {
            if (valid) {
               this.sub();
            } else {
               return this.$message({
                  message: "请完善必填信息",
                  type: "error",
               });
            }
         });
      },
      async sub() {
         let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
         var responseData
         if (this.dataActionBox.actionType==0) {
             responseData = await this.$http.supriceListadd(sendData);
         }else{
             responseData = await this.$http.supriceListupdate(sendData);
         }
         if (responseData.status == 200) {
            this.$message({
               message: "操作成功",
               type: "success",
            });
            this.$emit('drawerCancel', true)
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      // 过滤表单不同类型
      filterMainField() {
         var mainFormList = [];
         console.log(this.formDataList);
         this.formDataList.forEach((item) => {
            if (item.jciType == 1) {
               mainFormList.push(item);
            } else if (item.jciType == 2) {
               this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform));
            } else if (item.jciType == 3) {
               this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
            }
         });
         var arr = []
         var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
         for (let key in obj) {
            this.$set(this.sendDataInfo, key, obj[key])
         }
         mainFormList.forEach((key, i) => {
            this.tabForm[i] = JSON.parse(JSON.stringify(key));
            this.tabForm[i].jurconfigform = [];
            for (let index = 0; index < key.jurconfigform.length; index++) {
               if (key.jurconfigform[index].isShow == 1)
                  this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);
            }
         });

      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.$nextTick(() => {
         this.openBox()
      })
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() { },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() {
      this.getMainInput()
   }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
   height: 200px;
   background-color: red;
}

.table_content_box {
   /* height: 500px !important; */
   overflow-y: auto;
}

.el-row {
   display: flex;
   flex-wrap: wrap;
   padding-right: 20px;
}

.foot {
   display: flex;
   justify-content: center;
   align-items: center;
   width: 100%;
   background: #fff;
   padding: 14px 0;
   z-index: 999;
}

.foot .el-form {
   margin-left: 20px;
}

.foot .el-form .el-form-item {
   margin-bottom: 0;
}

.el-drawer {
   outline: none;
}

.mb {
   margin-bottom: 0;
}

.newInput {
   height: 28px;
   line-height: 28px;
   background-color: #fff;
   background-image: none;
   border-radius: 4px;
   border: 1px solid #dcdfe6;
   box-sizing: border-box;
   color: #606266;
   display: inline-block;
   font-size: inherit;
   outline: 0;
   padding: 0 15px;
   transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
   width: 100%;
}
</style>